import { jsx as s } from "react/jsx-runtime";
import { useState as n, createContext as d, useContext as i } from "react";
const r = d(void 0), C = ({ children: e }) => {
  const [t, o] = n(!1);
  return /* @__PURE__ */ s(r.Provider, { value: { isAnyOfChildrenFocused: t, setIsAnyOfChildrenFocused: o }, children: e });
}, c = () => {
  const e = i(r);
  if (!e)
    throw new Error("useCard must be used within a CardProvider");
  return e;
};
export {
  C as CardProvider,
  c as useCard
};
//# sourceMappingURL=index.es681.js.map
